// DUNSNumberRegistration.jsx
import React from "react";

export default function DUNSNumberRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            DUNS Number Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            DUNS Number Support for Global Recognition
          </h1>
          <div className="w-20 h-1 bg-indigo-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining a DUNS Number
            so they can appear in Dun &amp; Bradstreet’s global database and
            meet onboarding requirements of many international buyers and
            platforms.
          </p>
          <p className="text-gray-700">
            Support covers identifying the correct DUNS request path, preparing
            application data, and coordinating until the unique nine‑digit DUNS
            identifier is issued.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-indigo-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3735430/pexels-photo-3735430.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Global business networking and trade"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for DUNS Number
            </h2>
            <p className="text-gray-700 mb-4">
              DUNS applications generally rely on clear legal identity details,
              tax information, and verifiable business address information.
            </p>
            <div className="bg-gray-50 border border-indigo-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business details including legal name, registration number,
                  ownership type, contact person, phone, email, and website.
                </li>
                <li>
                  PAN card details of the entity or authorised person for tax
                  identification and verification.
                </li>
                <li>
                  Address proof of the registered office such as incorporation
                  certificate address, utility bill, rent agreement, or other
                  acceptable document.
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The objective is to ensure your DUNS profile is accurate, complete
              and aligned with international counterpart expectations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Global Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Advisory on how DUNS data is used by global buyers, credit
                  agencies and platforms so your profile supports future
                  onboarding.
                </p>
              </div>

              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Registration Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Careful preparation and review of each field and document to
                  minimise queries, mismatches, or processing delays.
                </p>
              </div>

              <div className="border-l-4 border-indigo-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance from initial data gathering through submission and
                  follow‑up, including guidance on updating DUNS details later.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-indigo-600 text-indigo-700 font-medium hover:bg-indigo-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
